import { gql } from '@apollo/client';

export const MARK_QUOTE_READ = gql`
  mutation readQuote($quoteId: String!) {
    markQuoteRead(quoteId: $quoteId) {
      complete
    }
  }
`;
